export default "__VITE_ASSET__BOp3AcAU__"